import { messages as validation } from "vee-validate/dist/locale/es.json";
import { countryList } from "@/locales/properNouns";
import messages from "./json/es.json";

export default {
  pl: {
    word: "{n} {word}",
  },
  validation: {
    ...validation,
    credit_card: "El campo {_field_} debe ser un número de tarjeta de crédito válido",
    required_select: validation.required,
  },
  notificationsText: {
    liked: "A {screenName} le gustó tu {type}",
    followed: "{screenName} te siguió",
    subscribed: "{screenName} se suscribió a ti por {price}",
    upgradeSubscription: "{screenName} mejoró su suscripción a ti. Ahora el nivel de suscripción es {price}",
    soldPost: "{screenName} compró tu publicación por {price}",
    soldAttachment: "{screenName} compró tu archivo adjunto por {price}",
    soldEvent: "{screenName} ha reservado tu evento {date} por {price}",
    eventPublished: "¡Próximo evento de {screenName}!",
    eventStarted: "El evento ha comenzado",
    eventCancelled: "{screenName} canceló el evento",
    sendReview: "{screenName} dejó un comentario: {review}",
    sendMentionedReview: "{screenName} te respondió: {review}",
    appointmentRequested: "{screenName} solicitó {appointmentType} contigo",
    appointmentApproved: "{screenName} aceptó {appointmentType} contigo",
    appointmentRejected: "{screenName} rechazó {appointmentType} contigo",
    appointmentCancelled: "{screenName} canceló {appointmentType} contigo",
    appointmentReminder: "Faltan {timeLeft} para la cita con {screenName}",
    appointmentNoResponse:
      "{screenName} no respondió a tu solicitud de {appointmentType}. El dinero fue devuelto a tu billetera",
    fundraisingFinished: "¡{goal} finalizado!",
    fundraisingStarted: "{screenName} ha establecido un {goal}",
    fundraisingDonationCreated: "{screenName} donó {amount} a {goal}",
  },
  ...countryList,
  ...messages,
};
